export default "__VITE_ASSET__Bl0rYq_T__"